var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ]
    },
    [
      _c("el-header", [
        _c("ul", { staticClass: "List-headr" }, [
          _c(
            "li",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.getList }
                },
                [_vm._v("刷新")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("开始日期：")]),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  placeholder: "选择日期",
                  size: "small",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyyMMdd",
                  clearable: false
                },
                on: {
                  change: function($event) {
                    _vm.myOption.restStartPage()
                    _vm.getList()
                  }
                },
                model: {
                  value: _vm.startDay,
                  callback: function($$v) {
                    _vm.startDay = $$v
                  },
                  expression: "startDay"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("结束日期：")]),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  placeholder: "选择日期",
                  size: "small",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyyMMdd",
                  clearable: false
                },
                on: {
                  change: function($event) {
                    _vm.myOption.restStartPage()
                    _vm.getList()
                  }
                },
                model: {
                  value: _vm.endDay,
                  callback: function($$v) {
                    _vm.endDay = $$v
                  },
                  expression: "endDay"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("动作类型：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { size: "small" },
                  on: {
                    change: function($event) {
                      _vm.myOption.restStartPage()
                      _vm.getList()
                    }
                  },
                  model: {
                    value: _vm.actionType,
                    callback: function($$v) {
                      _vm.actionType = $$v
                    },
                    expression: "actionType"
                  }
                },
                _vm._l(_vm.myOption.actionType, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("REQUEST_ID：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small" },
                on: { input: _vm.getList },
                model: {
                  value: _vm.requestId,
                  callback: function($$v) {
                    _vm.requestId = $$v
                  },
                  expression: "requestId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("IMEI：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small" },
                on: { input: _vm.getList },
                model: {
                  value: _vm.imei,
                  callback: function($$v) {
                    _vm.imei = $$v
                  },
                  expression: "imei"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("IMEI_MD5：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small" },
                on: { input: _vm.getList },
                model: {
                  value: _vm.imeiMd5,
                  callback: function($$v) {
                    _vm.imeiMd5 = $$v
                  },
                  expression: "imeiMd5"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("OAID：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small" },
                on: { input: _vm.getList },
                model: {
                  value: _vm.oaid,
                  callback: function($$v) {
                    _vm.oaid = $$v
                  },
                  expression: "oaid"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("ANDROID_ID：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small" },
                on: { input: _vm.getList },
                model: {
                  value: _vm.androidId,
                  callback: function($$v) {
                    _vm.androidId = $$v
                  },
                  expression: "androidId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("ANDROID_ID_MD5：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small" },
                on: { input: _vm.getList },
                model: {
                  value: _vm.androidIdMd5,
                  callback: function($$v) {
                    _vm.androidIdMd5 = $$v
                  },
                  expression: "androidIdMd5"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("代码位ID：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small" },
                on: { input: _vm.getList },
                model: {
                  value: _vm.slotId,
                  callback: function($$v) {
                    _vm.slotId = $$v
                  },
                  expression: "slotId"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "ListMain" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, height: "100%" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "__time__",
                  label: "时间",
                  "min-width": "180px",
                  fixed: "left"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "app_name",
                  label: "广告名称",
                  "min-width": "150px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "bid_type",
                  label: "竞价类型",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "simulate_bid",
                  label: "消耗（元）",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "action_type",
                  label: "动作类型",
                  "min-width": "130px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "request_id",
                  label: "REQUEST_ID",
                  "min-width": "300px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "imei", label: "IMEI", "min-width": "200px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "imei_md5",
                  label: "IMEI_MD5",
                  "min-width": "200px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "oaid", label: "OAID", "min-width": "140px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "oaid_md5",
                  label: "OAID_MD5",
                  "min-width": "140px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "android_id",
                  label: "ANDROID_ID",
                  "min-width": "200px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "android_id_md5",
                  label: "ANDROID_ID_MD5",
                  "min-width": "200px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "slot_id",
                  label: "代码位ID",
                  "min-width": "200px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "api_version",
                  label: "API版本",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ua", label: "UA", "min-width": "600px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ip", label: "IP", "min-width": "200px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "province", label: "省份", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "city", label: "城市", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "district", label: "区县", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "longitude",
                  label: "经度",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "latitude", label: "纬度", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "device_type",
                  label: "设备类型",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mccmnc", label: "运营商", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "vendor", label: "品牌", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "model", label: "机型", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "os_version",
                  label: "操作系统版本",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "os_type",
                  label: "操作系统类型",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "conn_type",
                  label: "设备的网络类型",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mac", label: "MAC", "min-width": "150px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dpi", label: "屏幕密度", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "screen_width",
                  label: "设备屏宽",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "screen_height",
                  label: "设备屏高",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "wifi_name",
                  label: "WIFI名称",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "wifi_mac",
                  label: "MAC地址",
                  "min-width": "140px"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-footer",
        [_c("Pagination", { attrs: { getList: _vm.getList } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-196e65b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196e65b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/log_stream/Report.vue
// module id = CM05
// module chunks = 1